import(/* webpackMode: "eager" */ "/app/src/app/home/[lang]/tos/PrivacyPolicyCLient.tsx")